import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function FadeIn({ children, delay = 0, y = 24, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskLines({ lines, accent = -1, className = "", delay = 0.1, stagger = 0.14 }) {
  return (
    <h1 className={className}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block ${i === accent ? "text-brand" : ""}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: delay + i * stagger, ease: EASE }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}

export function SectionHead({ num, eyebrow, title, sub, center = false }) {
  return (
    <FadeIn className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      <div className={`flex items-center gap-3 ${center ? "justify-center" : ""}`}>
        {num && (
          <span className="flex h-6 w-6 items-center justify-center bg-brand font-mono text-[11px] font-bold text-white">
            {num}
          </span>
        )}
        <span className="font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-brand">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-5 font-display text-3xl font-bold tracking-[-0.02em] text-ink sm:text-4xl lg:text-[2.6rem] lg:leading-[1.15]">
        {title}
      </h2>
      {sub && <p className="mt-4 text-base font-medium leading-relaxed text-ink2">{sub}</p>}
    </FadeIn>
  );
}

export function Corner({ pos }) {
  const cls = {
    tl: "top-0 left-0 border-t-2 border-l-2",
    tr: "top-0 right-0 border-t-2 border-r-2",
    bl: "bottom-0 left-0 border-b-2 border-l-2",
    br: "bottom-0 right-0 border-b-2 border-r-2",
  }[pos];
  return (
    <span
      aria-hidden
      className={`pointer-events-none absolute z-10 h-6 w-6 border-brand ${cls}`}
    />
  );
}
